// components/CourseCategoriesSection.jsx
import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Fade } from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';
import ScienceIcon from '@mui/icons-material/Science';
import LanguageIcon from '@mui/icons-material/Language';
import { motion } from 'framer-motion';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import EngineeringIcon from '@mui/icons-material/Engineering';


const categories = [
  {
    icon: <WorkOutlineIcon sx={{ fontSize: 50, color: '#ff6600' }} />,
    title: 'Professional Development',
    description: 'Upskill and stay competitive with expert-led training programs for the modern industry.',
  },
  {
    icon: <EngineeringIcon sx={{ fontSize: 50, color: '#ff6600' }} />,
    title: 'Technical Skills',
    description: 'Master operations with hands-on courses tailored to real-world applications.',
  },
  {
    icon: <LanguageIcon sx={{ fontSize: 50, color: '#ff6600' }} />,
    title: 'Communication & Language',
    description: 'Improve collaboration and broaden global opportunities through effective skills.',
  },
];

export default function CourseCategoriesSection() {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      {/* 🔁 Video Background */}
      <Box
        component="video"
        src="/mbs building.mp4" // replace with your actual video path
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />

      {/* 🔳 Gradient Overlay (optional for readability) */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(255,255,255,0.75), rgba(255,255,255,0.9))',
          zIndex: 1,
        }}
      />

      {/* Content Layer */}
      <Box
        component="section"
        sx={{
          py: 12,
          px: 4,
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
        }}
      >
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 'bold', color: '#ff6600' }}>
            Explore Course Categories
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ maxWidth: 600, mx: 'auto', mb: 6, color: 'text.secondary' }}
          >
            Professional learning pathways designed for modern industries and lifelong development.
          </Typography>
        </motion.div>

        {/* Cards */}
        <Grid container spacing={4} justifyContent="center">
          {categories.map((cat, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.2, duration: 0.5 }}
              >
                <Card
                  sx={{
                    p: 4,
                    borderRadius: 4,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                    height: '100%',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <CardContent>
                    <Box mb={2}>{cat.icon}</Box>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {cat.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {cat.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
